module.exports = __webpack_public_path__ + "img/calendar-filled.40530784.svg";